export type LearningNavigation = {
  tab?: 'books' | 'policies' | 'reminders' | 'reports';
  policy?: string;
  book?: string;
  paragraph?: string;
  section?: string;
  view?: 'questions' | 'theory';
};
export type LearningNavigate = (
  patch: Partial<LearningNavigation>,
  replace?: boolean,
  internal?: boolean,
) => void;
export function parseLearningNavigation(search: Record<string, unknown>): LearningNavigation {
  const result: LearningNavigation = {};
  if (
    typeof search.tab === 'string' &&
    ['books', 'policies', 'reminders', 'reports'].includes(search.tab)
  )
    result.tab = search.tab as LearningNavigation['tab'];
  if (search.view === 'questions' || search.view === 'theory') result.view = search.view;
  for (const key of ['book', 'paragraph', 'section', 'policy'] as const) {
    const value = search[key];
    if (typeof value === 'string' && value.trim() && value.length <= 128) result[key] = value;
  }
  return result;
}
